module.exports = __webpack_public_path__ + "static/media/streaming.8dabb56f.svg";